module.exports = "/static-assets/_next/static/images/phone-handset-straight-56321a8aefea1ec9cdd7d8a4b4310a61.png";